import { RouterProvider } from "react-router-dom";
import Router from "./routes";
import "./App.css";
import Header from './components/header'

export const App = () => {
  return (
    <div className="App">
        <RouterProvider router={Router} />
    </div>
  );
};

export default App;
